var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15825_358619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.54 5C6.6 5.89 6.75 6.76 6.99 7.59L5.79 8.79C5.38 7.59 5.12 6.32 5.03 5H6.54ZM16.4 17.02C17.25 17.26 18.12 17.41 19 17.47V18.96C17.68 18.87 16.41 18.61 15.2 18.21L16.4 17.02ZM7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.51C21 15.96 20.55 15.51 20 15.51C18.76 15.51 17.55 15.31 16.43 14.94C16.33 14.9 16.22 14.89 16.12 14.89C15.86 14.89 15.61 14.99 15.41 15.18L13.21 17.38C10.38 15.93 8.06 13.62 6.62 10.79L8.82 8.59C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    width: 14,
    height: 14,
    rx: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0013 1.16602C13.7813 1.16602 11.168 3.77935 11.168 6.99935C11.168 10.2193 13.7813 12.8327 17.0013 12.8327C20.2213 12.8327 22.8346 10.2193 22.8346 6.99935C22.8346 3.77935 20.2213 1.16602 17.0013 1.16602ZM17.5846 9.91602H16.418V8.74935H17.5846V9.91602ZM17.5846 7.58268H16.418V4.08268H17.5846V7.58268Z",
    fill: "#FF9800"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15825_358619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneWarning);
export default __webpack_public_path__ + "static/media/phone_warning.05c10413f46cb4b9e9487ed935111e03.svg";
export { ForwardRef as ReactComponent };